import { Response } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'
import { stringify } from 'qs'
import type { Product } from '@src/type/product'

export interface GetVendorProductsResponse extends Response {
	data: { products: Product[] }
}

export type SelectQuery = {
	lastPosNo?: string
	limit?: number
	titleIlk?: string
	keyword?: string
}
export const getVendorProducts = async ({
	lastPosNo,
	limit,
	titleIlk,
	keyword,
}: SelectQuery): Promise<GetVendorProductsResponse> => {
	const queryString = stringify({
		last_pos_no: lastPosNo,
		limit,
		title_ilk: titleIlk,
		keyword,
	})
	const response = await client.get<GetVendorProductsResponse>(`/vendors/products?${queryString}`)

	return response.data
}
